/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type EditDesignProjectTile_designProject = {
    readonly serviceId: string | null;
    readonly addressDisplayString: string | null;
    readonly internalEditUrl: string | null;
    readonly editUrl: string | null;
    readonly name: string | null;
    readonly rootId: number | null;
    readonly tradeCoverPhoto: {
        readonly path: string | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"DesignProjectTileStatusBadge_designProject" | "DeleteProjectConfirmationModal_designProject">;
    readonly " $refType": "EditDesignProjectTile_designProject";
};
export type EditDesignProjectTile_designProject$data = EditDesignProjectTile_designProject;
export type EditDesignProjectTile_designProject$key = {
    readonly " $data"?: EditDesignProjectTile_designProject$data;
    readonly " $fragmentRefs": FragmentRefs<"EditDesignProjectTile_designProject">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "EditDesignProjectTile_designProject",
  "type": "designProject",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "addressDisplayString",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "internalEditUrl",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "editUrl",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "name",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "rootId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "tradeCoverPhoto",
      "storageKey": null,
      "args": null,
      "concreteType": "TradePhoto",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "path",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "DesignProjectTileStatusBadge_designProject",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "DeleteProjectConfirmationModal_designProject",
      "args": null
    }
  ]
};
(node as any).hash = '6161146d85937476b00eeef1f713cdf8';
export default node;
